import { ForderungAufstellung } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG = 'HAFTPFLICHT-FORDERUNG-AUFSTELLUNG';

export interface HaftpflichtForderungAufstellungModelConfig extends DynamicFormValueControlModelConfig<ForderungAufstellung> {
}

export class HaftpflichtForderungAufstellungModel extends DynamicFormValueControlModel<ForderungAufstellung> {
  @serializable() readonly type: string = TYPE_HAFTPFLICHT_FORDERUNG_AUFSTELLUNG;

  constructor(config: HaftpflichtForderungAufstellungModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
